// Ordem da Lista e da Tabela da Central de Solicitações com "Mostrar subtarefas"
// ligado: cada subtarefa aparece logo abaixo da solicitação mãe, recuada. Antes
// elas caíam misturadas às demais pela ordenação (vencimento/prioridade) e não
// dava para saber de quem eram filhas.
//
// Função pura (testada em __tests__/subtarefasAgrupadas.test.ts). A subtarefa
// tem um nível só (parent_id aponta para uma solicitação sem parent_id).

export interface ItemComPai {
    id: string | number;
    parent_id?: string | number | null;
}

export interface LinhaAgrupada<T> {
    tarefa: T;
    /** 1 = subtarefa mostrada logo abaixo da mãe (recuada). */
    nivel: 0 | 1;
    /** Subtarefa cuja mãe não está na lista (filtrada, concluída escondida...) —
     *  fica na posição normal, mas continua marcada como subtarefa. */
    orfa: boolean;
}

const chave = (v: string | number) => String(v);

/**
 * Reordena `lista` (já filtrada e ordenada) para que as subtarefas venham logo
 * depois da mãe, na ordem relativa em que já estavam. Ninguém some nem duplica.
 */
export function agruparSubtarefas<T extends ItemComPai>(lista: T[]): LinhaAgrupada<T>[] {
    const presentes = new Set(lista.map(t => chave(t.id)));
    const filhasPorMae = new Map<string, T[]>();
    for (const t of lista) {
        if (t.parent_id == null || !presentes.has(chave(t.parent_id))) continue;
        const k = chave(t.parent_id);
        const filhas = filhasPorMae.get(k) || [];
        filhas.push(t);
        filhasPorMae.set(k, filhas);
    }

    const saida: LinhaAgrupada<T>[] = [];
    for (const t of lista) {
        const ehSubtarefa = t.parent_id != null;
        const maePresente = ehSubtarefa && presentes.has(chave(t.parent_id!));
        if (maePresente) continue; // entra logo abaixo da mãe
        saida.push({ tarefa: t, nivel: 0, orfa: ehSubtarefa });
        for (const filha of filhasPorMae.get(chave(t.id)) || []) {
            saida.push({ tarefa: filha, nivel: 1, orfa: false });
        }
    }
    return saida;
}
